/**
 * Patches material-table's DataManager so that the header "select all" checkbox
 * only selects/deselects rows on the current page, not the entire dataset.
 *
 * This must be imported once before any DataTable with selection renders.
 */

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
const DataManager = require('material-table/dist/utils/data-manager').default;

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
const originalChangeAllSelected = DataManager.prototype.changeAllSelected;

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
DataManager.prototype.changeAllSelected = function changeAllSelectedPageOnly(checked: boolean) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!this.paging) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    originalChangeAllSelected.call(this, checked);
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-plus-operands
  const startIndex = this.currentPage * this.pageSize;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-plus-operands
  const endIndex = startIndex + this.pageSize;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  const pageData: { tableData: { checked: boolean; disabled?: boolean } }[] = this.sortedData.slice(
    startIndex,
    endIndex,
  );

  // material-table's header checkbox state is based on selectedCount === dataCount (the full
  // filtered set), so its `checked` argument never flips to false under page-only semantics —
  // every click would otherwise stay stuck on select. Toggle based on the page's own state:
  // if every row on this page is already ticked, untick them; otherwise tick them.
  const allPageChecked = pageData.length > 0 && pageData.every((row) => row.tableData.checked);
  const shouldCheck = !allPageChecked;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, prefer-destructuring
  let selectedCount: number = this.selectedCount;
  pageData.forEach((row) => {
    const wasChecked = row.tableData.checked;
    const nowChecked = row.tableData.disabled ? false : shouldCheck;
    // eslint-disable-next-line no-param-reassign
    row.tableData.checked = nowChecked;
    // eslint-disable-next-line no-plusplus
    if (wasChecked && !nowChecked) selectedCount--;
    // eslint-disable-next-line no-plusplus
    if (!wasChecked && nowChecked) selectedCount++;
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  this.selectedCount = selectedCount;
};

export {};
